module.exports = __webpack_public_path__ + "img/alliance_medium.2215350e.png";